import { render } from "./Loader.vue?vue&type=template&id=cce5eb14&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=cce5eb14&scoped=true&lang=css"

import exportComponent from "/var/www/html/DOCKER-PROJECT/PDS/pds/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cce5eb14"]])

export default __exports__